<h1 mat-dialog-title class="p-2 text-center" i18n>Ajout de matrices </h1>
<div mat-dialog-content class="p-3">

    <div class="row">
        <mat-form-field class="col-12">
            <input matInput [(ngModel)]="Model.Name" i18n-placeholder placeholder="Name" required>
        </mat-form-field>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label i18n>Mot-clef</mat-label>
                <mat-chip-grid #chipGrid aria-label="Mot-clef" [formControl]="formControl">
                    @for (keyword of keywords; track keyword) {

                    <mat-chip-row color="primary" highlighted (removed)="removeKeyword(keyword)">
                        {{keyword}}
                        <button matChipRemove aria-label="retirer Mot-clef">
                            <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                    }
                    <input i18n-placeholder placeholder="Nouveau Mot-clef..."
                           [matChipInputFor]="chipGrid"
                           (matChipInputTokenEnd)="add($event)" />
                </mat-chip-grid>
            </mat-form-field>
        </div>
        <div class="col-auto">
            <button appPreventDoubleClick class="col me-1 h-75" color="basic" mat-stroked-button (throttledClick)="search()" i18n>
                Chercher
            </button>
        </div>
    </div>

    <mat-selection-list #shoes (selectionChange)="onSelection($event, shoes.selectedOptions)">
        @for (p of AvailableElimsProductList; track p.Eurodat5Code) {
        <mat-list-option [value]="p">
            {{p.ProductDescription}}
        </mat-list-option>
        }
    </mat-selection-list>
    <!-- NEW PRODUCT GROUP -->

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()" i18n>
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1 white" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()" i18n>
            Ajouter
        </button>
    </div>
</div>